import { allCountries } from '../i18n/countries';

// Map ISO country codes to phone dialing codes
// Now uses centralized data from countries.js instead of hardcoded mappings
export const getPhoneCodeFromCountry = (countryCode?: string): string => {
    if (!countryCode) return '359'; // Default to Bulgaria

    const country = allCountries.find(c => c.code === countryCode.toUpperCase());
    return country?.phone_code || '359'; // Default to Bulgaria if not found
};

// Map locale to phone code for self-registration
export const getPhoneCodeFromLocale = (locale?: string): string => {
    const localeToCountryMapping: { [key: string]: string } = {
        'BG': 'BG',  // Bulgarian → Bulgaria
        'TR': 'TR',  // Turkish → Turkey
        'EN': 'BG',  // English → Default to Bulgaria (primary market)
    };

    const countryCode = localeToCountryMapping[locale?.toUpperCase() || ''] || 'BG';
    return getPhoneCodeFromCountry(countryCode);
};
